/* Mantener el acceso a WhatsApp separado de los controles de compra. */
(() => {
  if (window.creditexFloatingUIReady) return;
  window.creditexFloatingUIReady = true;
  const original = new WeakMap();
  const candidates = 'a[href*="wa.me"], a[href*="api.whatsapp.com"], a[href*="web.whatsapp.com"], [aria-label*="whatsapp" i], [title*="whatsapp" i], img[alt*="whatsapp" i], iframe[src*="whatsapp" i]';
  let scheduled = false;

  function restore(element, property, saved) {
    if (saved.value) element.style.setProperty(property, saved.value, saved.priority);
    else element.style.removeProperty(property);
  }

  function update() {
    scheduled = false;
    const modalOpen = !!document.querySelector('cart-drawer.active, quick-add-modal[open], header-drawer > details[open], menu-drawer > details[open]');
    const bar = document.querySelector('.creditex-sticky-atc.is-visible');
    const barHeight = bar && getComputedStyle(bar).display !== 'none' ? bar.getBoundingClientRect().height : 0;
    const fixedWidgets = new Set();
    document.querySelectorAll(candidates).forEach(candidate => {
      for (let element = candidate; element && element !== document.body; element = element.parentElement) {
        const style = getComputedStyle(element);
        if (style.position !== 'fixed') continue;
        const bounds = element.getBoundingClientRect();
        // Sólo el lanzador compacto, sin mover enlaces del contenido o ventanas de chat.
        if (bounds.width > 220 || bounds.height > 220) continue;
        fixedWidgets.add(element);
        break;
      }
    });
    fixedWidgets.forEach(element => {
      let saved = original.get(element);
      if (!saved) {
        const style = getComputedStyle(element);
        saved = {
          bottom: { value: element.style.getPropertyValue('bottom'), priority: element.style.getPropertyPriority('bottom') },
          visibility: { value: element.style.getPropertyValue('visibility'), priority: element.style.getPropertyPriority('visibility') },
          bottomOffset: parseFloat(style.bottom),
        };
        original.set(element, saved);
      }
      if (modalOpen) element.style.setProperty('visibility', 'hidden', 'important');
      else restore(element, 'visibility', saved.visibility);
      if (barHeight && Number.isFinite(saved.bottomOffset)) {
        element.style.setProperty('bottom', `${Math.max(saved.bottomOffset, barHeight + 14)}px`, 'important');
      } else restore(element, 'bottom', saved.bottom);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  new MutationObserver(schedule).observe(document.body, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open'],
  });
  window.addEventListener('resize', schedule);
  schedule();
})();
